import { render, staticRenderFns } from "./Workbook.vue?vue&type=template&id=c09f6c3e&scoped=true"
import script from "./Workbook.vue?vue&type=script&lang=js"
export * from "./Workbook.vue?vue&type=script&lang=js"
import style0 from "./Workbook.vue?vue&type=style&index=0&id=c09f6c3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09f6c3e",
  null
  
)

export default component.exports